import { useMemo } from 'react'
import { GroupBase } from 'react-select'
import { observer } from 'mobx-react'

import { Field } from 'Components/Field/Field'
import { FieldTypeEnum } from 'Components/Field/Field.types'
import { SelectOption } from 'Components/Select/Select.types'

import { useCountryList } from 'Hooks'

import { CountrySelectProps } from './CountrySelect.types'

export const CountrySelect = observer(
  <
    Option extends SelectOption,
    IsMulti extends boolean,
    Group extends GroupBase<Option> = GroupBase<Option>,
  >(
    props: CountrySelectProps<Option, IsMulti, Group>,
  ) => {
    const countryList = useCountryList()

    const countryOptions = useMemo(
      () =>
        Object.keys(countryList).map(isoCode => ({
          label: countryList[isoCode],
          value: isoCode,
        })),
      [countryList],
    )

    return (
      <Field
        {...props}
        selectProps={{
          isClearable: true,
          options: countryOptions,
        }}
        type={FieldTypeEnum.select}
      />
    )
  },
)
